import { render, staticRenderFns } from "./details.vue?vue&type=template&id=3625d4aa&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625d4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3625d4aa')) {
      api.createRecord('3625d4aa', component.options)
    } else {
      api.reload('3625d4aa', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=3625d4aa&scoped=true", function () {
      api.rerender('3625d4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/details.vue"
export default component.exports